import React from 'react';

interface ProgressBarProps {
    acceptValue: number;
    rejectedValue: number;
    max: number; 
    className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ acceptValue, rejectedValue, max, className }) => {
    const acceptValuePercentage = Math.min((acceptValue / max) * 100, 100); // Ensure it doesn't exceed 100%
    const rejectedValuePercentage = Math.min((rejectedValue / max) * 100, 100); // Ensure it doesn't exceed 100%

    return (
        <div className={`w-full flex bg-gray-200 rounded-full h-4 ${className || ''}`}>
            <div
                className={`bg-green-500 h-full transition-all ${rejectedValue ? 'rounded-l-full' : 'rounded-full'}`}
                style={{ width: `${acceptValuePercentage}%` }}
                aria-label={`Progress: ${acceptValuePercentage}%`}
            ></div>
            <div
                className="bg-red-500 h-full rounded-r-full transition-all"
                style={{ width: `${rejectedValuePercentage}%` }}
                aria-label={`Progress: ${rejectedValuePercentage}%`}
            ></div>
        </div>
    );
};

export default ProgressBar;
